import { useCallback } from 'react';

import type { useCustomer } from '@order/Customer';
import type { Address } from '@order/graphql';

import type { AddressForm } from '../../../../components/Address/AddressForm.types';
import { useUpdateAddressMutation } from '../../../../components/Address/GraphQL/Address.generated';

export const useUpdateAddress = (props: HandleUpdateAddressProps) => {
  const [updateAddressResponse, updateAddress] = useUpdateAddressMutation();
  const submittingAddress = updateAddressResponse?.fetching;

  const handleUpdateAddress = useCallback(
    async (form: AddressForm) => {
      const input = { ...form, id: props.addressId ?? '' };

      // eslint-disable-next-line functional/immutable-data, functional/prefer-readonly-type
      delete (input as unknown as { __typename: never }).__typename;
      const response = await updateAddress({ input });
      const data = response.data?.updateAddress;

      if (data?.__typename === 'UpdateAddressSuccess') {
        const addresses: readonly Address[] = props.customer?.addresses ?? [];
        const updatedId = data?.address.id;
        const filtered = addresses.filter(({ id }) => id !== updatedId);
        const updatedAddresses = [...filtered, data.address];

        props.setCustomerData({
          ...props.customer,
          addresses: updatedAddresses,
        });
      }
    },
    [props, updateAddress],
  );

  return {
    submittingAddress,
    handleUpdateAddress,
  };
};

type HandleUpdateAddressProps = {
  readonly addressId?: string;
  readonly customer: ReturnType<typeof useCustomer>['customer'];
  readonly setCustomerData: ReturnType<typeof useCustomer>['setCustomerData'];
};
